import type {
  EditPostInput,
  PostInputMetaData,
  SchedulingType,
} from './graphqlTypes'

import type { Service } from '../graphqlEnums'
import type { ChannelVariant } from '../store/postSlice/types'
import { mapChannelVariantAssets } from './channelVariantToCreatePostInput'
import { resolveEditScheduling } from './resolveEditScheduling'
import type { MapperContext } from './types'

/**
 * `resolveEditScheduling` omits `mode`/`dueAt` entirely when the schedule
 * wasn't touched, so the server preserves the post's placement.
 * `approvalChange` is tri-state — absent leaves approval alone, and unlike
 * create's `needsApproval`, a prior request can be withdrawn.
 */
export function channelVariantToEditPostInput(
  variant: ChannelVariant,
  service: Service,
  metadata: PostInputMetaData,
  ctx: MapperContext,
  postId: string,
): EditPostInput {
  // Reminder vs direct is per-channel: legacy `reminder`/`direct` → GraphQL
  // `notification`/`automatic`.
  const schedulingType: SchedulingType = variant.isReminder
    ? 'notification'
    : 'automatic'

  return {
    id: postId,
    text: variant.text,
    schedulingType,
    assets: mapChannelVariantAssets(variant.assets, service),
    tagIds: ctx.selectedTagIds,
    aiAssisted: variant.aiAssisted,
    metadata,
    ...resolveEditScheduling(ctx),
    ...(ctx.saveToDraft != null ? { saveToDraft: ctx.saveToDraft } : {}),
    ...(ctx.ideaId != null ? { ideaId: ctx.ideaId } : {}),
    ...(ctx.draftId != null ? { draftId: ctx.draftId } : {}),
    ...(ctx.source != null ? { source: ctx.source } : {}),
    ...(ctx.requestApproval !== undefined
      ? { approvalChange: ctx.requestApproval ? 'request' : 'revert' }
      : {}),
  }
}
